import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
//import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from "@material-ui/core/ListItemText";
//import Collapse from '@material-ui/core/Collapse';
//import InboxIcon from '@material-ui/icons/MoveToInbox';
//import DraftsIcon from '@material-ui/icons/Drafts';
//import SendIcon from '@material-ui/icons/Send';
//import ExpandLess from '@material-ui/icons/ExpandLess';
//import ExpandMore from '@material-ui/icons/ExpandMore';
//import StarBorder from '@material-ui/icons/StarBorder';
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";

import GlobalVariables from "../../GlobalVariables";
import HeaderLanguageButtons from "./HeaderLanguageButtons";

const styles = theme => ({
  root: {
    width: "100%",
    maxWidth: 250,
    backgroundColor: theme.palette.background.paper
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4
  }
});

class NestedList extends React.Component {
  constructor(props) {
    super(props);
    this.childInstance = null;
  }

  state = {
    open: true
  };

  /*
  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };
  */
  componentDidMount() {
    this.onRouteChanged(this.props);
  }

  onRouteChanged(currentProps) {
    this.childInstance.updatePathsByParent(GlobalVariables, currentProps);
  }

  getLangText(langJson) {
    return GlobalVariables.currentLang
      ? langJson[GlobalVariables.currentLang]
      : langJson["tc"];
  }

  getLink(page) {
    if (GlobalVariables.currentLang == "tc") {
      return page ? "/" + page : "";
    }

    if (page == "") {
      return GlobalVariables.currentLang
        ? "/" + GlobalVariables.currentLang
        : "/" + page;
    } else {
      return GlobalVariables.currentLang
        ? "/" + GlobalVariables.currentLang + "/" + page
        : "/" + page;
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div
        className={
          classes.root + (GlobalVariables.currentLang === "en" ? " en" : "")
        }
      >
        <List
          component="nav"
          subheader={<ListSubheader component="div">&nbsp;</ListSubheader>}
        >
          <ListItem button style={{ paddingTop: "6px", paddingBottom: "6px" }}>
            {/*}
            <ListItemIcon>
              <SendIcon />
            </ListItemIcon>
            */}
            <Link to={this.getLink("")} style={{ textDecoration: "none" }}>
              <ListItemText
                className="theme-font-family"
                primary={this.getLangText({
                  tc: "首頁",
                  sc: "首页",
                  en: "Home"
                })}
              />
            </Link>
          </ListItem>
          <ListItem button style={{ paddingTop: "6px", paddingBottom: "6px" }}>
            <Link
              to={this.getLink("about-us")}
              style={{ textDecoration: "none" }}
            >
              <ListItemText
                className="theme-font-family"
                primary={this.getLangText({
                  tc: "關於我們",
                  sc: "关于我们",
                  en: "About Us"
                })}
              />
            </Link>
          </ListItem>
          {/* <ListItem button style={{ paddingTop: "6px", paddingBottom: "6px" }}>
            <Link
              to={this.getLink("about-us")}
              style={{ textDecoration: "none" }}
            >
              <ListItemText
                inset
                className="theme-font-family"
                primary={this.getLangText({
                  tc: "集團介紹",
                  sc: "集团介绍",
                  en: "Introduction"
                })}
              />
            </Link>
          </ListItem> */}
          {/* <ListItem button style={{ paddingTop: "6px", paddingBottom: "6px" }}>
            <Link
              to={this.getLink("awards-recognitions")}
              style={{ textDecoration: "none" }}
            >
              <ListItemText
                inset
                className="theme-font-family"
                primary={this.getLangText({
                  tc: "獎項殊榮",
                  sc: "奖项殊荣",
                  en: "Awards & Recognitions"
                })}
              />
            </Link>
          </ListItem> */}
          <ListItem button style={{ paddingTop: "6px", paddingBottom: "6px" }}>
            <Link to={this.getLink("forex")} style={{ textDecoration: "none" }}>
              <ListItemText
                className="theme-font-family"
                primary={this.getLangText({
                  tc: "公司業務",
                  sc: "公司业务",
                  en: "Businesses"
                })}
              />
            </Link>
          </ListItem>
          <ListItem button style={{ paddingTop: "6px", paddingBottom: "6px" }}>
            <Link to={this.getLink("forex")} style={{ textDecoration: "none" }}>
              <ListItemText
                inset
                className="theme-font-family"
                primary={this.getLangText({
                  tc: "技術咨詢",
                  sc: "技术咨询",
                  en: "Financial Technology"
                })}
              />
            </Link>
          </ListItem>
          {/*
						<ListItem button style={{ paddingTop: "6px", paddingBottom: "6px" }}>
	            <Link
	              to={this.getLink("precious-metals")}
	              style={{ textDecoration: "none" }}
	            >
	              <ListItemText
	                inset
	                className="theme-font-family"
	                primary={this.getLangText({
	                  tc: "貴金屬",
	                  sc: "贵金属",
	                  en: "Precious Metals"
	                })}
	              />
	            </Link>
	          </ListItem>
						*/}

          <ListItem button style={{ paddingTop: "6px", paddingBottom: "6px" }}>
            <Link
              to={this.getLink("asset-management")}
              style={{ textDecoration: "none" }}
            >
              <ListItemText
                inset
                className="theme-font-family"
                primary={this.getLangText({
                  tc: "運營咨詢",
                  sc: "运营咨询",
                  en: "Operations Consulting"
                })}
              />
            </Link>
          </ListItem>
          {/*
						<ListItem button style={{ paddingTop: "6px", paddingBottom: "6px" }}>
	            <Link
	              to={this.getLink("press-center")}
	              style={{ textDecoration: "none" }}
	            >
	              <ListItemText
	                className="theme-font-family"
	                primary={this.getLangText({
	                  tc: "最新消息",
	                  sc: "最新消息",
	                  en: "News"
	                })}
	              />
	            </Link>
	          </ListItem>

          <ListItem button style={{ paddingTop: "6px", paddingBottom: "6px" }}>
            <Link
              to={this.getLink("press-center")}
              style={{ textDecoration: "none" }}
            >
              <ListItemText
                inset
                className="theme-font-family"
                primary={this.getLangText({
                  tc: "新聞中心",
                  sc: "新闻中心",
                  en: "Press Center"
                })}
              />
            </Link>
          </ListItem>
						*/}
          <ListItem button style={{ paddingTop: "6px", paddingBottom: "6px" }}>
            <Link
              to={this.getLink("contact-us")}
              style={{ textDecoration: "none" }}
            >
              <ListItemText
                className="theme-font-family"
                primary={this.getLangText({
                  tc: "聯絡我們",
                  sc: "联络我们",
                  en: "Contact Us"
                })}
              />
            </Link>
          </ListItem>
          {/*}
          <ListItem button onClick={this.handleClick} style={{ paddingTop:'6px', paddingBottom:'6px'}} >
            <ListItemIcon>
              <InboxIcon />
            </ListItemIcon>
            <ListItemText inset primary="Inbox" />
            {this.state.open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          */}
          {/*
          <Collapse in={this.state.open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button className={classes.nested} style={{ paddingTop:'6px', paddingBottom:'6px'}} >
                <ListItemIcon>
                  <StarBorder />
                </ListItemIcon>
                <ListItemText inset primary="Starred" />
              </ListItem>
            </List>
          </Collapse>
          */}
        </List>
        <Divider />
        <Grid container justify="flex-start">
          <Grid item>
            <div
              className="header-buttons-item-wrapper default-text-color"
              style={{ padding: "6px 0" }}
            >
              <HeaderLanguageButtons
                provideInstance={instance => (this.childInstance = instance)}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

NestedList.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(NestedList);



// WEBPACK FOOTER //
// ./src/components/pages/includes/MenuDrawerList.js